import { render } from "./Home.vue?vue&type=template&id=7dc664e5&scoped=true"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=7dc664e5&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7dc664e5"

export default script